import { useState, useEffect } from 'react';
import React  from 'react';
import { Link }  from 'react-router-dom';


function Navbar() {

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const navbarElement = document.getElementById('navbar');

      if (navbarElement) {
        const scrollTop = window.scrollY;
        const navbarHeight = navbarElement.offsetHeight;

        setIsSticky(scrollTop >= navbarHeight);
      }
    };

    // Check scroll position on mount (important for page refresh)
    handleScroll();

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`sticky-wrapper ${isSticky ? 'is-sticky' : ''}`}>
        <nav id="navbar" className="navbar navbar-expand-lg">
            <div className="container">
                <Link className="navbar-brand" to="/" >
                    <i className="bi-back"></i>
                    <span> just59</span>
                </Link>

                {/* <div className="d-lg-none ms-auto me-4">
                    <a href="#top" className="navbar-icon bi-person smoothscroll"></a>
                </div> */}

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <Link className="nav-link click-scroll" to="/" activeClassName="active">Home</Link>
                            </li>

                            {/* <li className="nav-item">
                                <Link className="nav-link click-scroll" to="/browse-calculators" activeClassName="active">Browse Calculators</Link>
                            </li> */}

                            <li className="nav-item">
                                <Link className="nav-link click-scroll" to="/about-us" activeClassName="active">About Us</Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link click-scroll" to="/faqs" activeClassName="active">FAQs</Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link click-scroll" to="/contact" activeClassName="active">Contact Us</Link>
                            </li>
                        </ul>

                        {/* <div className="d-none d-lg-block">
                            <a href="#top" className="navbar-icon bi-person smoothscroll"></a>
                        </div> */}
                    </div>
            </div>
    </nav>
    </div>
    
  )
}

export default Navbar
